const baseUrl = 'https://events-globstudy.herokuapp.com';

export default baseUrl;